export default __webpack_public_path__ + "static/media/about.d4347111.svg";